import { useEffect, useRef } from "react";

/**
 * Calls `refresh` every `intervalMs` while Hub is visible, and right away when the
 * user returns to the tab or app. Hidden tabs make no requests.
 */
export function useLiveRefresh(refresh: () => void, intervalMs: number, enabled = true): void {
  const refreshRef = useRef(refresh);

  useEffect(() => {
    refreshRef.current = refresh;
  }, [refresh]);

  useEffect(() => {
    if (!enabled) return;
    const run = () => {
      if (document.visibilityState === "visible") refreshRef.current();
    };
    const timer = window.setInterval(run, intervalMs);
    document.addEventListener("visibilitychange", run);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", run);
    };
  }, [intervalMs, enabled]);
}
